const { $ } = window;

$(() => {
  console.log("this is archive.js");
  const searchElement = document.querySelector(".c-archive__search");
  if (searchElement) {
    const searchTitleElement = searchElement.querySelector(
      ".c-archive__search-title"
    );
    if (!searchTitleElement) {
      throw new Error("searchTitleElement is null");
    }
    const searchCloseElement = searchElement.querySelector(
      ".c-archive__search-close"
    );
    if (!searchCloseElement) {
      throw new Error("searchCloseElement is null");
    }
    const searchContentElement = searchElement.querySelector(
      ".c-archive__search-content"
    );
    if (!searchContentElement) {
      throw new Error("searchContentElement is null");
    }
    const onClickOpenClose = (event) => {
      const classNameOpen = "c-archive__search--opened";
      if (searchElement.classList.contains(classNameOpen)) {
        searchElement.classList.remove(classNameOpen);
        $(searchContentElement).slideUp();
      } else {
        searchElement.classList.add(classNameOpen);
        $(searchContentElement).slideDown();
      }
    };
    searchTitleElement.addEventListener("click", onClickOpenClose);
    searchCloseElement.addEventListener("click", onClickOpenClose);
  }
});
